import { render, staticRenderFns } from "./InboxEmailIcon.vue?vue&type=template&id=33d631b6&"
import script from "./InboxEmailIcon.vue?vue&type=script&lang=js&"
export * from "./InboxEmailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports